
import { colorSchemes, proColorSchemes } from "@/components/FunnelBuilder/constants";
import type { FunnelData } from "@/components/FunnelBuilder/types";

export const getThemeColors = (funnel: FunnelData) => {
  return (funnel.isPro && funnel.theme in proColorSchemes) 
    ? proColorSchemes[funnel.theme as keyof typeof proColorSchemes]
    : (funnel.theme in colorSchemes)
      ? colorSchemes[funnel.theme as keyof typeof colorSchemes]
      : colorSchemes.slateLight;
};
